import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import JwtLoginView from "./jwt-login-view";

export default function LoginPage() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5",
      }}
    >
      <Grid
        container
        sx={{
          width: { xs: "90%", md: "70%" },
          height: { xs: "80vh", md: "70vh" },
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: 4,
        }}
      >
        {/* Left Section */}
        <Grid
          item
          xs={12}
          md={5} // smaller than right side
          sx={{
            bgcolor: "#0B0C10",
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            p: 4,
          }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Welcome Back
          </Typography>
          <Typography variant="subtitle1">
            Let’s get you signed in to continue.
          </Typography>
        </Grid>

        {/* Right Section */}
        <Grid
          item
          xs={12}
          md={7} // bigger than left side
          sx={{
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 4,
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <JwtLoginView />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
